import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { GenericResponse } from 'src/app/entities/various';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatsService {
  private e_invoiceUrl : string =  environment.url;
  //private e_invoiceUrl: string = AppConfig.settings.apiServer.url;

  constructor(private http: HttpClient) { }

  async getTable(managerId : string|number, params: HttpParams) : Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + managerId + "/stats_managed_users", {params: params})
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async getResellers (managerId : string | number) : Promise<GenericResponse> {
    let params = new HttpParams();
    params = params.append('searchFilter', '{\"role\":\"R\"}');
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + managerId + "/managed_users", {params: params})
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })

  }
}
 